<form [formRoot]="form" class="app-form">
  <div class="form-group">
    <label class="col-form-label text-[14px]!"><strong>{{ 'LABELS.PASSWORD' | translate }}</strong></label>
    <div class="relative" data-field-wrapper>
      <input
        id="password"
        class="form-control pr-16"
        [formField]="form.password"
        placeholder="Enter your password"
        autocomplete="current-password"
        [type]="revealPassword() ? 'text' : 'password'"
        appFormFieldOnError
      />
      <app-password-visibility-toggle [revealed]="revealPassword()" (toggled)="togglePasswordVisibility()" />
    </div>
  </div>
  @if (incorrectPassword()) {
  <app-alert class="mt-4!" [dismissible]="true" (closed)="dismissIncorrectPassword.emit()" type="danger">
    {{ active() === 1 ? ('MESSAGES.ERRORS.INCORRECT_EMAIL_OR_PASSWORD' | translate) :
    ('MESSAGES.ERRORS.INCORRECT_MOBILE_OR_PASSWORD' | translate) }}
  </app-alert>
  }
  <br />
  <button
    [class.loader--text]="authService.showLoader"
    [disabled]="form().invalid() || form().submitting()"
    class="btn btn-gradient btn-block forgot-password"
    type="submit"
  >
    <span>Login</span>
  </button>
</form>
